import * as types from "./types";
import { PluginsService } from "../../services/plugins.service";

export const bookingPluginsActions = {
  async [types.BOOKING_PLUGINS.FETCH.ALL]({ commit, getters }, payload) {
    const pluginsData = await PluginsService.findAll();
    console.log(pluginsData);
    commit(types.BOOKING_PLUGINS.SET.ALL, pluginsData.data);
  }
};
